import React from 'react';
import { htmlContestRules } from './Nucleo/ContestRules_CPHIFrankfurt_gonucleo.docx';
import { useDocumentTitle } from '../../../helpers/hooks';
import LegalContentFrame from './LegalContentFrame';

export default function ContestRulesPage() {
  useDocumentTitle('Contest Rules');

  return (
    <LegalContentFrame html={htmlContestRules} title="Terms of Use" />
  );
}
